import { Helmet } from "react-helmet-async";
import { StepperItem, Layout, Button, Input, Dropdown, TableRowResponsive, StepperItemMobile, CustomModal , Textarea, DatePickerInput } from "../../components";
import { IssuingController } from "../../controllers";
import  { Add , Arrowdown2, Calendar3, Cancel, ChatSquare , Money, Reply, User  } from "../../../assets";
import { Accordion, AccordionDetails, AccordionSummary, Alert , Skeleton, Tab, Tabs } from "@mui/material";
import "chart.js/auto";
import { DateObject } from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian"
import { fixNumbers, showPercentTitle, soldierStatus } from "../../../core/utils";
import { connect } from "react-redux";
import moment from "moment-jalaali";



class Issuing extends IssuingController {

    componentDidMount() {
        window.scrollTo(0, 0);
        this.getRelationPerson()
        if (window.location.pathname.split("/")[2]) {
            this.getDefaultIssuing(true);
          }else{
        this.limitationBeneficiary("")
        this.getQuestionnaireList()
            
          }
    }
    render() {
        const { insuredEqualPolicyHolder } = this.props;
    
        const { inqueryRegisterOfficeData, inqueryRegisterOfficeData2,
            policy_holder_national_code,
            insured_national_code,
            base64Data,
            base64Loading,
            step1Errors,
            step3Errors,
            step3_2Errors,
            step,
            contentLoading,
            tabIndex,
            tabs,
            hasError,
            cityListLoading,
            openBeneficiaryModal,
            beneficiaryModalStep,
            disease_policy_holder,
            public_policy_holder,
            disease_insured,
            public_insured,
            policy_holder_is_married,
            policy_holder_mobile,
            policy_holder_postal_code,
            policy_holder_address,
            policy_holder_weight,
            policy_holder_height,
            policy_holder_city_id,
            policy_holder_soldier_status,
            insured_soldier_status,
            insured_is_married,
            insured_mobile,
            insured_postal_code,
            insured_address,
            insured_weight,
            insured_height,
            insured_city_id,
            life_bens,
            death_bens,
            step4Errors,
            policy_holder_province_id,
            insured_province_id,
            relation_id, percent, priority, national_code, birthdayLife,
            province_list,
            policy_city_list,
            insured_city_list,
            relationPersonList,
            relation_with_policy_holder,
            step5Errors,
            step5_2Errors,
            step6Errors,
            step6_2Errors,
            isLife,
            filteredRelationPersonList,
            hasErrorMsg,
            openConfirmationInformationModal,
            new_policy_holder,
            is_withdrawal_from_savings,
            sharesList,
            shareId,
            person_type
        } = this.state;
        return (
            <Layout title = "  ثبت پیشنهاد بیمه زندگی و سرمایه گذاری " > 
            <Helmet>
                <title>  ثبت پیشنهاد بیمه  | بیمه زندگی هامرز </title>
            </Helmet>
                <div className="inquery scrollbar">
                    <div className="inquery-container ">
                        <div className="inquery-stepper hide-mobile">
                            <div className="stepper-container">
                                <StepperItem stepTitle="مرحله اول" stepDesc="مشخصات بیمه گذار و بیمه شده " step={1} activeStep={step} >
                                    <div className="step-in-step">
                                        {/* active-step-title */}
                                        <span className={`step-title ${this.state.step >= 1 ? "active-step-title" : ""} mt-2`}>
                                            1.استعلام اطلاعات بیمه گذار و بیمه شده
                                        </span>
                                        <span className={`step-title ${this.state.step >= 2 ? "active-step-title" : ""} mt-2`}>
                                            2.تایید و ثبت اطلاعات طرفین
                                        </span>
                                        <span className={`step-title ${this.state.step >= 3 ? "active-step-title" : ""} mt-2`}>
                                            3.تکمیل اطلاعات
                                        </span>
                                    </div>
                                </StepperItem>
                                <StepperItem stepTitle="مرحله دوم" stepDesc="تعیین استفاده کنندگان" step={4} activeStep={step} />
                                {this.props.inqueryData?.start_death_asset > this.props.inqueryData?.minimum_insurance_premium && (
                                <StepperItem stepTitle="مرحله سوم" stepDesc="پرسشنامه" step={5} activeStep={step}>
                                <div className="step-in-step">
                                        <span className={`step-title ${this.state.step >= 5 ? "active-step-title" : ""} mt-2`}>
                                            1.سوالات عمومی
                                        </span>
                                        <span className={`step-title ${this.state.step >= 6 ? "active-step-title" : ""} mt-2`}>
                                            2.سوالات پزشکی
                                        </span>
                                    </div>
                                    </StepperItem>
                            )}
                                <StepperItem stepTitle={this.props.inqueryData?.start_death_asset > this.props.inqueryData?.minimum_insurance_premium ? "مرحله چهارم " : "مرحله سوم"} stepDesc="پرداخت" step={7} activeStep={step} />
                            </div>
                        </div>
                        <div className={`inquery-content inquery-content-center h-100`}>
                            <>
                            <div className=" hide-desktop ">
                    {step === 7 ?
                        <></>
                        :
                        <>
                            {contentLoading ? <div className="stepper-loading w-100">
                                <div className="content-loading "></div>
                                <div className="content-loading mt-2"></div>
                            </div>
                                :
                                <>
                                    <div className="inquery-title">

                                        {(step === 1 || step === 2 || step === 2|| step === 3) &&
                                           "اطلاعات هویتی"}
                                        {step === 4 && "اطلاعات هویتی استفاده کننده "}
                                        {step === 5 && "سوالات عمومی "}
                                        {step === 6 && "سوالات پزشکی"}

                                    </div>
                                    <div className="stepper-container-mobile">
                                        <StepperItemMobile step={7} activeStep={step} />
                                        <StepperItemMobile step={5} activeStep={step} >
                                    <div className="mobile-step-in">
                                        <div className={`${step >= 6 ? "mobile-step-active" : "mobile-step-deactive"} item`}></div>
                                        <div className={`${step >= 5 ? "mobile-step-active" : "mobile-step-deactive"} item`}></div>
                                    </div>
                                </StepperItemMobile>
                                        <StepperItemMobile step={4} activeStep={step} />
                                        <StepperItemMobile step={1} activeStep={step} >
                                    <div className="mobile-step-in">
                                    <div className={`${step > 2 ? "mobile-step-active" : "mobile-step-deactive"} item`}></div>
                                        <div className={`${step > 1 ? "mobile-step-active" : "mobile-step-deactive"} item`}></div>
                                        <div className={`mobile-step-active item`}></div>
                                    </div>
                                </StepperItemMobile>


                                    </div>
                                </>
                            }
                            <br />
                         
                        </>
                    }
                </div>
                                {/* {step !== 7 &&

                                    <div className=" hide-mobile">
                                        <span className="inquery-title">
                                            {contentLoading && step !== 6 ?
                                                <div className="content-loading"></div> :
                                                <>صدور پیشنهاد بیمه نامه
                                                </>
                                            }
                                        </span>
                                        <p className="inquery-description">

                                            {contentLoading && step !== 6 ?
                                                <div className="content-loading mt-2"></div>
                                                : <>
                                                    {step === 2 ?
                                                        <>
                                                            اطلاعات زیر از طریق سازمان ثبت احوال استعلام گرفته شده اند<br /> پس از بررسی دقیق در صورت مغایرت با اطلاعات خود آنهار را اصلاح نمایید

                                                        </>
                                                        :
                                                        <>
                                                            جهت صدور پیشنهاد بیمه نامه اطلاعات خواسته شده را به درستی تکمیل نمایید
                                                        </>
                                                    }
                                                </>
                                            }
                                        </p>
                                    </div>} */}
                                    
                                {step === 1 &&
                                <>
                                {hasError &&

<Alert variant="filled" severity="error" sx={{ bgcolor: '#FF6240', width: "100%", borderRadius: "8px", minHeightn: "48px", maxWidth: "555px", marginBottom: "10px" , textAlign:"left"}}>
{hasErrorMsg}                                         
 </Alert>
}
                                    <div className="inquery-form inquery-form-center step-1">
                                    <div className="row-container ">
                                        
                                        <div className="row-container  w-48 hide-mobile">
                                            <span className="inquery-section-title d-flex align-items-baseline text-end w-100 ms-0">

                                                {contentLoading ? <div className="content-loading"></div> :
                                                    <>
                                                        {insuredEqualPolicyHolder ?
                                                            <>
                                                                اطلاعات هویتی بیمه گذار /بیمه شده
                                                            </>
                                                            :
                                                            <>
                                                                اطلاعات هویتی بیمه گذار
                                                            </>
                                                        }

                                                    </>
                                                }
                                                <hr className="hr-line" />
                                            </span>
                                        </div>
                                        {!insuredEqualPolicyHolder && 
                                            <>
                                                <div className="row-container row-container-center hide-mobile w-48">
                                                    <span className="inquery-section-title d-flex align-items-baseline text-end w-100 ms-0">
                                                        {contentLoading ? <div className="content-loading"></div> :
                                                            <>
                                                                اطلاعات هویتی بیمه شده
                                                            </>
                                                        }
                                                        <hr className="hr-line" />
                                                    </span>
                                                </div>
                                               
                                            </>
                                        }
                                        </div>

                                        <div className="row-container">
                                            <Input  max="11" disabled contentLoading={contentLoading} error={step1Errors?.filter((name: { path: string; }) => name.path === "policy_holder_national_code")?.[0]?.errors?.[0]} hideEndAdornment isRequired type="number" endAdornment="" iconBorder icon={<img src={User} alt="هامرز"/>} myStyle="inquery-input w-48" lable="کد ملی بیمه گذار" value={policy_holder_national_code} onChange={(e: any) => this.changeNationalCodeHolder(e)} />
                                        {!insuredEqualPolicyHolder && 

                                            <Input max="11" contentLoading={contentLoading} error={step1Errors?.filter((name: { path: string; }) => name.path === "insured_national_code")?.[0]?.errors?.[0]} hideEndAdornment isRequired type="number" endAdornment="" iconBorder icon={<img src={User} alt="هامرز"/>} myStyle="inquery-input w-48" lable="کد ملی بیمه شده" value={insured_national_code} onChange={(e: any) => this.changeNationalCodeInsured(e)} />
                                            }
                                        </div>

                                       
                                        <div className="row-container ">
                                        
                                        <div className="row-container  w-48 hide-mobile">
                                            <span className="inquery-section-title d-flex align-items-baseline text-end w-100 ms-0">

                                                {contentLoading ? <div className="content-loading"></div> :
                                                    <>
                                                       اطلاعات بیمه نامه 

                                                    </>
                                                }
                                                <hr className="hr-line" />
                                            </span>
                                        </div>
                                            <>
                                                <div className="row-container row-container-center hide-mobile w-48">
                                                    <span className="inquery-section-title d-flex align-items-baseline text-end w-100 ms-0">
                                                        {contentLoading ? <div className="content-loading"></div> :
                                                            <>
                                                                برداشت از اندوخته
                                                            </>
                                                        }
                                                        <hr className="hr-line" />
                                                    </span>
                                                </div>
                                               
                                            </>
                                        </div>
                                        <div className="row-container ">

                                                        <Dropdown contentLoading={contentLoading} isRequired objectList items={
                                                            [
                                                                {
                                                                    value: "INSURED", title: "بیمه شده"
                                                                },
                                                                {
                                                                    value: "USERS CONDITION OF LIFE", title: "استفاده کنندگان به شرط حیات"
                                                                },
                                                                {
                                                                    value: "LEGAL HEIRS", title: "وراث قانونی بیمه گذار"
                                                                }
                                                            ]
                                                        } error={step1Errors?.filter((name: { path: string; }) => name.path === "new_policy_holder")?.[0]?.errors?.[0]}
                                                            iconBorder displayEmpty myStyle="inquery-dropdown w-48 " lable="بیمه گذار جدید" hasNotice="درصورت فوت بیمه‌گذار در طی مدت بیمه‌نامه، بیمه‌گذار جدید چه کسی باشد؟" placeholder="  انتخاب کنید " value={new_policy_holder} onChange={(e: any) => this.setState({ new_policy_holder: e.target.value })} />

<Dropdown contentLoading={contentLoading} isRequired objectList items={
                                                            [
                                                                {
                                                                    value: true, title: "بله"
                                                                },
                                                                {
                                                                    value: false, title: "خیر"
                                                                }
                                                            ]
                                                        } error={step1Errors?.filter((name: { path: string; }) => name.path === "is_withdrawal_from_savings")?.[0]?.errors?.[0]}
                                                            iconBorder hasNotice="درصورت تاخیر در پرداخت اقساط، آیا تامین حق‌بیمه پوشش‌های تکمیلی حوادث از اندوخته بیمه‌نامه صورت پذیرد؟" displayEmpty myStyle="inquery-dropdown w-48 " lable="تامین حق‌بیمه حوادث از اندوخته , در صورت تاخیر اقساط" placeholder="  انتخاب کنید " value={is_withdrawal_from_savings} onChange={(e: any) => this.setState({ is_withdrawal_from_savings: e.target.value })} />

                                    </div>
                                    
                                    </div>

                                </>

                                }
                                {step === 2 &&
                                    <>
                                        <div className="inquery-form inquery-form-center step-2 ">
                                            {insuredEqualPolicyHolder ? <>
                                                {contentLoading ? <div className="content-loading hide-mobile"></div> :
                                                    <div className="row-container hide-mobile">
                                                        <span className="inquery-section-title d-flex align-items-baseline ms-0 w-100">

                                                            اطلاعات هویتی بیمه گذار /بیمه شده

                                                            <hr className="hr-line" />
                                                        </span>
                                                    </div>
                                                }
                                            </> :
                                                <div className="inquery-tab mb-5 ">

                                                    <div className={`${this.state.tab === 0 ? "inquery-tab-item-active" : ""} inquery-tab-item`} onClick={()=>this.setState({tab:0})}>
                                                        <div className={`${this.state.tab === 0 ? "tab-active" : "tab-deactive"} tab-style`} >
                                                        اطلاعات بیمه گذار
                                                        </div>
                                                        {this.state.tab === 0 &&
                                                            <span className="up-arrow"></span>
                                                        }
                                                    </div>

                                                    <div className={`${this.state.tab === 1 ? "inquery-tab-item-active" : ""} inquery-tab-item`} onClick={()=>this.setState({tab: 1})}>

                                                        <div className={`${this.state.tab === 1 ? "tab-active" : "tab-deactive"} tab-style`} >
                                                            اطلاعات بیمه شده
                                                        </div>
                                                        {this.state.tab === 1 &&
                                                            <span className="up-arrow"></span>
                                                        }
                                                    </div>

                                                </div>
                                            }
                                            {this.state.tab === 0 ? <>

                                                <div className="row-container row-container-disable">
                                                    <Input hideEndAdornment type="number" myStyle="inquery-disable-input w-48 " lable="نام" value={inqueryRegisterOfficeData?.policy_holder?.Name} onChange={() => { }} />
                                                    <Input hideEndAdornment type="number" myStyle="inquery-disable-input w-48 " lable="نام خانوادگی" value={inqueryRegisterOfficeData?.policy_holder?.Family} onChange={() => { }} />

                                                </div>
                                                <div className="row-container row-container-disable">
                                                    <Input hideEndAdornment type="number" myStyle="inquery-disable-input w-48 " lable="نام پدر" value={inqueryRegisterOfficeData?.policy_holder?.FatherName} onChange={() => { }} />
                                                    <Input hideEndAdornment type="number" myStyle="inquery-disable-input w-48 " lable="جنسیت " value={inqueryRegisterOfficeData?.policy_holder?.Gender === "0" ? "زن" : "مرد"} onChange={() => { }} />

                                                </div>
                                                <div className="row-container row-container-disable">
                                                    <Input hideEndAdornment type="number" myStyle="inquery-disable-input w-48 " lable="کدملی" value={inqueryRegisterOfficeData?.policy_holder?.Nin} onChange={() => { }} />
                                                    <Input hideEndAdornment type="number" myStyle="inquery-disable-input w-48 " lable="شماره شناسنامه" value={inqueryRegisterOfficeData?.policy_holder?.ShenasnameNo} onChange={() => { }} />
                                                </div>
                                            </>
                                                :
                                                <>
                                                    <div className="row-container row-container-disable">
                                                        <Input hideEndAdornment type="number" myStyle="inquery-disable-input w-48 " lable="نام" value={inqueryRegisterOfficeData?.insured?.Name} onChange={() => { }} />
                                                        <Input hideEndAdornment type="number" myStyle="inquery-disable-input w-48 " lable="نام خانوادگی" value={inqueryRegisterOfficeData?.insured?.Family} onChange={() => { }} />

                                                    </div>
                                                    <div className="row-container row-container-disable">
                                                        <Input hideEndAdornment type="number" myStyle="inquery-disable-input w-48 " lable="نام پدر" value={inqueryRegisterOfficeData?.insured?.FatherName} onChange={() => { }} />
                                                        <Input hideEndAdornment type="number" myStyle="inquery-disable-input w-48 " lable="جنسیت " value={inqueryRegisterOfficeData?.insured?.Gender === "0" ? "زن" : "مرد"} onChange={() => { }} />

                                                    </div>
                                                    <div className="row-container row-container-disable">
                                                        <Input hideEndAdornment type="number" myStyle="inquery-disable-input w-48 " lable="کدملی" value={inqueryRegisterOfficeData?.insured?.Nin} onChange={() => { }} />
                                                        <Input hideEndAdornment type="number" myStyle="inquery-disable-input w-48 " lable="شماره شناسنامه" value={inqueryRegisterOfficeData?.insured?.ShenasnameNo} onChange={() => { }} />
                                                    </div>
                                                </>
                                            }
                                        </div>
                                    </>
                                }
                                {step === 3 &&
                                    <>
                                        <div className="inquery-form  step-2">
                                            {insuredEqualPolicyHolder ? <>
                                                {contentLoading ? <div className="content-loading  hide-mobile"></div> :
                                                    <div className="row-container  hide-mobile">
                                                        <span className="inquery-section-title ms-0  d-flex align-items-baseline w-100">
                                                            اطلاعات هویتی بیمه گذار /بیمه شده
                                                            <hr className="hr-line" />
                                                        </span>
                                                    </div>
                                                }
                                            </> :
                                                <div className="inquery-tab mb-5">
                                                    <div className={`${this.state.tab === 0 ? "inquery-tab-item-active" : ""} inquery-tab-item`} onClick={()=>this.setState({tab: 0})}>
                                                        <div className={`${this.state.tab === 0 ? "tab-active" : "tab-deactive"} tab-style`} >
                                                            اطلاعات بیمه گذار
                                                        </div>
                                                        {this.state.tab === 0 &&
                                                            <span className="up-arrow"></span>
                                                        }
                                                    </div>
                                                    <div className={`${this.state.tab === 1 ? "inquery-tab-item-active" : ""} inquery-tab-item`} onClick={()=>this.setState({tab: 1})}>

                                                        <div className={`${this.state.tab === 1 ? "tab-active" : "tab-deactive"} tab-style`} >
                                                        اطلاعات بیمه شده
                                                        </div>
                                                        {this.state.tab === 1 &&
                                                            <span className="up-arrow"></span>
                                                        }
                                                    </div>
                                                </div>
                                            }

                                            {this.state.tab === 0 &&
                                                <>
                                                    <div className="row-container ">
                                                        <Dropdown isRequired objectList items={
                                                            [
                                                                {
                                                                    value: true, title: "متاهل"
                                                                }, {
                                                                    value: false, title: "مجرد"

                                                                }
                                                            ]
                                                        } error={step3Errors?.filter((name: { path: string; }) => name.path === "policy_holder_is_married")?.[0]?.errors?.[0]}
                                                            iconBorder displayEmpty myStyle="inquery-dropdown w-48 " lable="وضعیت تاهل" placeholder="  انتخاب کنید " value={policy_holder_is_married} onChange={(e: any) => this.setState({ policy_holder_is_married: e.target.value })} />
                                                        <Input max="11"  isRequired error={step3Errors?.filter((name: { path: string; }) => name.path === "policy_holder_mobile")?.[0]?.errors?.[0]} hideEndAdornment type="number" iconBorder myStyle="inquery-input w-48 " lable="تلفن همراه" placeholder="تلفن همراه خود را اینجا وارد کنید" value={policy_holder_mobile} onChange={(e: any) => {}} disabled />
                                                    </div>
                                                    <div className="row-container ">
                                                        <Input isRequired error={step3Errors?.filter((name: { path: string; }) => name.path === "policy_holder_weight")?.[0]?.errors?.[0]} hideEndAdornment type="number" iconBorder myStyle="inquery-input w-48 " lable="وزن   (برحسب کیلوگرم)" max="3" placeholder="وزن را اینجا وارد کنید" value={policy_holder_weight} onChange={(e: any) => this.setState({ policy_holder_weight: e })} />

                                                        <Input isRequired error={step3Errors?.filter((name: { path: string; }) => name.path === "policy_holder_height")?.[0]?.errors?.[0]} hideEndAdornment type="number" iconBorder myStyle="inquery-input w-48 " lable="قد   (برحسب سانتی متر)"  max="3" placeholder="قد را اینجا وارد کنید" value={policy_holder_height} onChange={(e: any) => this.setState({ policy_holder_height: e })} />
                                                    </div>
                                                    <div className="row-container ">

                                                        <Dropdown isRequired objectList items={province_list} error={step3Errors?.filter((name: { path: string; }) => name.path === "policy_holder_province_id")?.[0]?.errors?.[0]} iconBorder displayEmpty myStyle="inquery-dropdown w-48 " lable="استان (محل سکونت) " placeholder="  انتخاب کنید " value={policy_holder_province_id} onChange={(e: any) => this.selectedProvince(e)} />
                                                        <Dropdown loading={cityListLoading} isRequired objectList disabled={policy_holder_province_id === "" ? true : false} items={policy_city_list} error={step3Errors?.filter((name: { path: string; }) => name.path === "policy_holder_city_id")?.[0]?.errors?.[0]} iconBorder displayEmpty myStyle="inquery-dropdown w-48 " lable=" شهر (محل سکونت) " placeholder="  انتخاب کنید " value={policy_holder_city_id} onChange={(e: any) => this.setState({ policy_holder_city_id: e.target.value })} />

                                                    </div>

                                            
                                        
                                                    <div className="row-container ">
                                                   
                                                        <Input isRequired error={step3Errors?.filter((name: { path: string; }) => name.path === "policy_holder_postal_code")?.[0]?.errors?.[0]} hideEndAdornment type="number" max="10" iconBorder myStyle="inquery-input w-48 " lable="کد پستی" placeholder="کدپستی 10 رقمی را اینجا وارد کنید" value={policy_holder_postal_code} onChange={(e: any) => this.setState({ policy_holder_postal_code: e })} />
                                                        {inqueryRegisterOfficeData?.policy_holder?.Gender === "1" &&
                                                        <Dropdown isRequired objectList items={soldierStatus} error={step3Errors?.filter((name: { path: string; }) => name.path === "policy_holder_soldier_status")?.[0]?.errors?.[0]} iconBorder displayEmpty myStyle="inquery-dropdown w-48 " lable="وضعیت سربازی" placeholder="  انتخاب کنید " value={policy_holder_soldier_status} onChange={(e: any) => this.setState({ policy_holder_soldier_status: e.target.value })} />

                                                     }
                                                    </div>
                                        
                                      

                                        
                                                    <div className="row-container ">
                                                        <Input isRequired error={step3Errors?.filter((name: { path: string; }) => name.path === "policy_holder_address")?.[0]?.errors?.[0]} hideEndAdornment iconBorder myStyle="inquery-input " lable="نشانی (محل سکونت) " placeholder="نشانی را اینجا وارد کنید" value={policy_holder_address} onChange={(e: any) => this.setState({ policy_holder_address: e })} />
                                                    </div>

                                                </>
                                            }
                                            {this.state.tab === 1 &&
                                                <>
                                                    <div className="row-container ">
                                                        <Dropdown isRequired objectList items={
                                                            [
                                                                {
                                                                    value: true, title: "متاهل"
                                                                }, {
                                                                    value: false, title: "مجرد"
                                                                }
                                                            ]
                                                        } error={step3_2Errors?.filter((name: { path: string; }) => name.path === "insured_is_married")?.[0]?.errors?.[0]}
                                                            iconBorder displayEmpty myStyle="inquery-dropdown w-48 " lable="وضعیت تاهل" placeholder="  انتخاب کنید " value={insured_is_married} onChange={(e: any) => this.setState({ insured_is_married: e.target.value })} />
                                                        <Input isRequired max="11" error={step3_2Errors?.filter((name: { path: string; }) => name.path === "insured_mobile")?.[0]?.errors?.[0]} hideEndAdornment type="number" iconBorder myStyle="inquery-input w-48 " lable="تلفن همراه" placeholder="تلفن همراه خود را اینجا وارد کنید" value={insured_mobile} onChange={(e: any) => this.setState({ insured_mobile: e })} />
                                                    </div>
                                                    {!insuredEqualPolicyHolder && 

                                                    <div className="row-container ">

                                                        <Dropdown isRequired objectList items={relationPersonList.filter((x: { value: number; }) => x.value !== 1 && x.value !== 2 && x.value !== 3)} error={step3_2Errors?.filter((name: { path: string; }) => name.path === "relation_with_policy_holder")?.[0]?.errors?.[0]} iconBorder displayEmpty myStyle="inquery-dropdown w-100 " lable="نسبت با بیمه گذار" placeholder="  انتخاب کنید " value={relation_with_policy_holder} onChange={(e: any) => this.setState({ relation_with_policy_holder: e.target.value })} />

                                                    </div>
                                                    }
                                                   
                                                    <div className="row-container ">
                                                        <Input isRequired error={step3_2Errors?.filter((name: { path: string; }) => name.path === "insured_weight")?.[0]?.errors?.[0]} hideEndAdornment type="number" iconBorder myStyle="inquery-input w-48 " lable="  وزن (برحسب کیلوگرم)  " max="3" placeholder="وزن را اینجا وارد کنید"  value={insured_weight} onChange={(e: any) => this.setState({ insured_weight: e })} />
                                                        <Input isRequired error={step3_2Errors?.filter((name: { path: string; }) => name.path === "insured_height")?.[0]?.errors?.[0]} hideEndAdornment type="number" iconBorder myStyle="inquery-input w-48 " lable=" قد (برحسب سانتی متر)"  max="3" placeholder="قد را اینجا وارد کنید" value={insured_height} onChange={(e: any) => this.setState({ insured_height: e })} />
                                                    </div>
                                                   
                                                    <div className="row-container ">
                                                        <Dropdown isRequired objectList items={province_list} error={step3_2Errors?.filter((name: { path: string; }) => name.path === "insured_province_id")?.[0]?.errors?.[0]} iconBorder displayEmpty myStyle="inquery-dropdown w-48 " lable="استان (محل سکونت) " placeholder="  انتخاب کنید " value={insured_province_id} onChange={(e: any) => this.selectedInsuredProvince(e)} />
                                                        <Dropdown isRequired objectList loading={cityListLoading} disabled={insured_province_id === "" ? true : false} items={insured_city_list} error={step3_2Errors?.filter((name: { path: string; }) => name.path === "insured_city_id")?.[0]?.errors?.[0]} iconBorder displayEmpty myStyle="inquery-dropdown w-48 " lable=" شهر (محل سکونت) " placeholder="  انتخاب کنید " value={insured_city_id} onChange={(e: any) => this.setState({ insured_city_id: e.target.value })} />
                                                    </div>

                                                    <div className="row-container ">
                                                    {inqueryRegisterOfficeData?.insured?.Gender === "1" &&
                                                    <Dropdown isRequired objectList items={soldierStatus} error={step3_2Errors?.filter((name: { path: string; }) => name.path === "insured_soldier_status")?.[0]?.errors?.[0]} iconBorder displayEmpty myStyle="inquery-dropdown w-48 " lable="وضعیت سربازی" placeholder="  انتخاب کنید " value={insured_soldier_status} onChange={(e: any) => this.setState({ insured_soldier_status: e.target.value })} />
                                                    }
                                                    <Input isRequired error={step3_2Errors?.filter((name: { path: string; }) => name.path === "insured_postal_code")?.[0]?.errors?.[0]} hideEndAdornment type="number" iconBorder myStyle="inquery-input w-48 " max="10" lable="کد پستی" placeholder="کدپستی 10 رقمی را اینجا وارد کنید" value={insured_postal_code} onChange={(e: any) => this.setState({ insured_postal_code: e })} />
                                                    
                                                    </div>
                                            
                                                    <div className="row-container ">
                                                        <Input isRequired error={step3_2Errors?.filter((name: { path: string; }) => name.path === "insured_address")?.[0]?.errors?.[0]} hideEndAdornment iconBorder myStyle="inquery-input " lable="نشانی (محل سکونت) " placeholder="نشانی را اینجا وارد کنید" value={insured_address} onChange={(e: any) => this.setState({ insured_address: e })} />
                                                    </div>
                                                </>
                                            }
                                        </div>
                                    </>
                                }
                                {step === 4 &&
                                    <>
                                        <div className="inquery-form ">
                                            {contentLoading ? <div className="content-loading"></div> :
                                                <div className="row-container">
                                                    <span className="inquery-section-title d-flex align-items-baseline w-100 text-end my-2 ms-0">
                                                        اطلاعات هویتی استفاده کنندگان در صورت فوت
                                                        <hr className="hr-line" />
                                                    </span>
                                                </div>
                                            }
                                            <div className="issuing-table">
                                                <table className="table hide-mobile">
                                                    <thead>
                                                        <tr>
                                                            <th scope="col">ردیف</th>
                                                            <th scope="col">نام و نام خانوادگي(شركت)</th>
                                                            <th scope="col">كدملي / شناسه ملي </th>
                                                            <th scope="col"> تاريخ تولد  </th>
                                                            <th scope="col">نسبت با بيمه شده</th>
                                                            <th scope="col">درصد سهم</th>
                                                            <th scope="col">اولویت </th> 
                                                            <th scope="col"> عملیات </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {death_bens && death_bens.length > 0 && death_bens?.map((item: any, index: number) => (

                                                            <tr key={index}>
                                                                <th>{index + 1}</th>
                                                                <th>{(item?.first_name || "---") + " " + (item?.last_name || "---")}</th>
                                                                <th>{item?.national_code || "---"}</th>
                                                                <th>{fixNumbers(item?.birthday && item?.birthday?.format()) || "---"}</th>
                                                                <th>{relationPersonList.find((element: { value: any; }) => element?.value === item?.relation_id)?.title}</th>
                                                                <th>{`${showPercentTitle(item?.percent)}`|| "---"}</th>
                                                                <th>{item?.priority}</th>
                                                                <th>
                                                                    <span className="remove" onClick={() => this.removeDeathObj(index,item?.priority)}>حذف</span>
                                                                </th>
                                                            </tr>
                                                        )
                                                        )}
                                                    </tbody>
                                                    <tfoot>
                                                        <tr><td colSpan={8} onClick={() => this.handleOpenModal(false)}>
                                                            <img src={Add} alt="هامرز"/>
                                                            افزودن  استفاده کننده 
                                                        </td></tr>
                                                    </tfoot>

                                                </table>
                                                <div className="policy w-100 table-responsive my-2 hide-desktop">
                                                
                                                   
                                                {death_bens && death_bens.length > 0 ? death_bens?.map((item: any, index: number) => (

<Accordion className="policy-accordion">
<AccordionSummary
    expandIcon={<img src={Arrowdown2} alt="هامرز" />}
    aria-controls="panel1a-content"
    className="summsry"
    id="panel1a-header"
>
    <TableRowResponsive myStyle="col-6" title="ردیف" value={index + 1} />

    <TableRowResponsive myStyle="col-6" value={(item?.first_name || "---") + " " + (item?.last_name || "---")} title="نام و نام خانوادگي(شركت)" />
</AccordionSummary>
<AccordionDetails
    className="d-flex flex-wrap"
>
    <TableRowResponsive myStyle="col-6" title="كدملي / شناسه ملي " value={item?.national_code || "---"} />
    <TableRowResponsive myStyle="col-6" title="تاريخ تولد " value={fixNumbers(item?.birthday && item?.birthday?.format()) || "---"} />


</AccordionDetails>
<AccordionDetails
    className="d-flex flex-wrap"
>
    <TableRowResponsive myStyle="col-6" title="نسبت با بيمه شده" value={relationPersonList.find((element: { value: any; }) => element?.value === item?.relation_id)?.title} />
    <TableRowResponsive myStyle="col-6" title="درصد سهم" value={`${showPercentTitle(item?.percent)}%`|| "---"} />


</AccordionDetails>
<AccordionDetails
    className="d-flex flex-wrap"
>
<TableRowResponsive myStyle="col-6" title="اولویت" value={`${item?.priority}`|| "---"} />
    <TableRowResponsive title=" عملیات " value="حذف" onClick={() => this.removeDeathObj(index,item?.priority)}/>
</AccordionDetails>
<AccordionDetails
    className="d-flex flex-wrap"
>
    
</AccordionDetails>
</Accordion>
))
:
<div className="no-gainer">
هیچ استفاده کننده ای  افزوده نشده 
</div>
}
                                       
                                       <div className="gainer" onClick={() => this.handleOpenModal(false)}>
                                                            <img src={Add} alt="هامرز"/>
                                                            افزودن استفاده کننده 
                                                        </div>                                       
                                        </div>
                                    </div>
                                {step4Errors?.filter((name: { path: string; }) => name.path === "death_bens")?.[0]?.errors?.[0] && 
                                
                                        <label className="custom-input-error">
                    {step4Errors?.filter((name: { path: string; }) => name.path === "death_bens")?.[0]?.errors?.[0]}
                </label>
                                
                                }
                                        </div>
                                        <div className="inquery-form">
                                            {contentLoading ? <div className="content-loading"></div> :
                                                <div className="row-container">
                                                    <span className="inquery-section-title d-flex align-items-baseline w-100 text-end my-2 ms-0">
                                                        اطلاعات هویتی استفاده کنندگان در صورت حیات
                                                        <hr className="hr-line" />
                                                    </span>
                                                </div>
                                            }
                                            <div className="issuing-table">
                                                <table className="table hide-mobile">
                                                    <thead>
                                                        <tr>
                                                            <th scope="col">ردیف</th>

                                                            <th scope="col">نام و نام خانوادگي(شركت)</th>
                                                            <th scope="col">كدملي / شناسه ملي </th>
                                                            <th scope="col"> تاريخ تولد  </th>
                                                            <th scope="col">نسبت با بيمه شده</th>
                                                            <th scope="col">درصد سهم</th>
                                                            <th scope="col">اولویت </th>
                                                            <th scope="col"> عملیات </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>

                                                        {life_bens && life_bens.length > 0 && life_bens?.map((item: any, index: number) => (
                                                            <tr key={index}>
                                                                <th>{index + 1}</th>
                                                                <th>{(item?.first_name || "---") + " " + (item?.last_name || "---")}</th>
                                                                <th>{item?.national_code || "---"}</th>
                                                                <th>{fixNumbers(item?.birthday && item?.birthday?.format()) || "---"}</th>

                                                                <th>{relationPersonList?.find((element: { value: any; }) => element?.value === item?.relation_id)?.title}</th>
                                                                <th>{showPercentTitle(item?.percent) || "---"}</th>
                                                                <th>{item?.priority}</th>
                                                                <th>

                                                                    <span className="remove" onClick={() => this.removeLifeObj(index,item?.priority)}>حذف</span>
                                                                </th>
                                                            </tr>
                                                        )
                                                        )}
                                                    </tbody>
                                                    <tfoot>

                                                        <tr><td colSpan={8} onClick={() => this.handleOpenModal(true)}>
                                                            <img src={Add} alt="هامرز"/>
                                                            افزودن استفاده کننده 
                                                        </td></tr>
                                                    </tfoot>

                                                </table>
                                                <div className="policy w-100 table-responsive my-2 hide-desktop">
                                                {life_bens && life_bens.length > 0 ? life_bens?.map((item: any, index: number) => (

<Accordion className="policy-accordion ">
<AccordionSummary
    expandIcon={<img src={Arrowdown2} alt="هامرز" />}
    aria-controls="panel1a-content"
    className="summsry"
    id="panel1a-header"
>
    <TableRowResponsive myStyle="col-6" title="ردیف" value={index + 1} />

    <TableRowResponsive myStyle="col-6" value={item?.first_name || "---" + " " + item?.last_name || "---" } title="نام و نام خانوادگي(شركت)" />
</AccordionSummary>
<AccordionDetails
    className="d-flex flex-wrap"
>
    <TableRowResponsive myStyle="col-6" title="كدملي / شناسه ملي " value={item?.national_code || "---"} />
    <TableRowResponsive myStyle="col-6" title="تاريخ تولد " value={fixNumbers(item?.birthday && item?.birthday?.format()) || "---"} />


</AccordionDetails>
<AccordionDetails
    className="d-flex flex-wrap"
>
    <TableRowResponsive myStyle="col-6" title="نسبت با بيمه شده" value={relationPersonList.find((element: { value: any; }) => element?.value === item?.relation_id)?.title} />
    <TableRowResponsive myStyle="col-6" title="درصد سهم" value={`${showPercentTitle(item?.percent)}%`|| "---"} />


</AccordionDetails>
<AccordionDetails
    className="d-flex flex-wrap"
>
<TableRowResponsive myStyle="col-6" title="اولویت" value={`${item?.priority}`|| "---"} />
<TableRowResponsive title=" عملیات " value="حذف" onClick={() => this.removeLifeObj(index,item?.priority)}/>

</AccordionDetails>
<AccordionDetails
    className="d-flex flex-wrap"
>
    
</AccordionDetails>
</Accordion>
))
:
<div className="no-gainer">
هیچ استفاده کننده ای  افزوده نشده 
</div>}
                                       
                                       <div className="gainer" onClick={() => this.handleOpenModal(true)}>
                                                            <img src={Add} alt="هامرز" />
                                                            افزودن استفاده کننده 
                                                        </div>                                       
                                        </div>
                                            </div>
                                        {step4Errors?.filter((name: { path: string; }) => name.path === "life_bens")?.[0]?.errors?.[0] && 
                                
                                        <label className="custom-input-error">
                    {step4Errors?.filter((name: { path: string; }) => name.path === "life_bens")?.[0]?.errors?.[0]}
                </label>
                                
                                }
                                        </div>
                                    </>
                                }

                                {step === 5 &&
                                    <div className="inquery-form">
                                        {insuredEqualPolicyHolder ? <>
                                            {contentLoading ? <div className="content-loading hide-mobile"></div> :
                                                <div className="row-container hide-mobile">
                                                    <span className="inquery-section-title d-flex align-items-baseline ms-0 w-100">

                                                        سوالات عمومی بیمه گذار /بیمه شده

                                                        <hr className="hr-line" />
                                                    </span>
                                                </div>
                                            }
                                        </> :
                                            <div className="inquery-tab mb-5">

                                                <div className={`${this.state.tab === 0 ? "inquery-tab-item-active" : ""} inquery-tab-item`} onClick={()=>this.setState({tab: 0})}>
                                                    <div className={`${this.state.tab === 0 ? "tab-active" : "tab-deactive"} tab-style`} >
                                                       
                                                    سوالات عمومی بیمه گذار
                                                    </div>
                                                    {this.state.tab === 0 &&
                                                        <span className="up-arrow"></span>
                                                    }
                                                </div>

                                                <div className={`${this.state.tab === 1 ? "inquery-tab-item-active" : ""} inquery-tab-item`} onClick={()=>this.setState({tab: 1})}>

                                                    <div className={`${this.state.tab === 1 ? "tab-active" : "tab-deactive"} tab-style`} >
                                                       


                                                        سوالات عمومی بیمه شده
                                                    </div>
                                                    {this.state.tab === 1 &&
                                                        <span className="up-arrow"></span>
                                                    }
                                                </div>
                                            </div>
                                        }
                                        {this.state.tab === 0 && <>
                                            {public_policy_holder && public_policy_holder?.length > 0 && public_policy_holder?.map((item: any, index: number) => (

                                                <div className={`questionnaire`}>
                                                    <div className="questionnaire-qu-an">
                                                        <span className="question mt-1">
                                                            {contentLoading ?
                                                                <div className="input-loading-lable content-loading">
                                                                </div>
                                                                :
                                                                <>
                                                                    {index + 1 }<span className="circle"></span>{item?.title}
                                                                </>
                                                            }
                                                        </span>
                                                        <Dropdown error={step5Errors?.filter((name: { path: string; }) => name.path === `public_policy_holder[${index}].default_value`)?.[0]?.errors?.[0]} contentLoading={contentLoading} objectList items={item?.value_types} iconBorder displayEmpty myStyle="answer inquery-dropdown " lable="" placeholder="  انتخاب کنید " value={item?.default_value} onChange={(e: any) => { this.onQuestionPolicyPublicHolderChange(index, "default_value", e.target.value) }} />
                                                    </div>

                                                    {/* {value && */}
                                                    <div className="questionnaire-description-box">
                                                        {item?.value_types?.find((item2: { value: string; }) => Number(item2.value) === Number(item.default_value))?.description_required && 
                                                            <>
                                                                {!contentLoading &&
                                                                    <Reply color="#000000" myStyle="reply" />
                                                                }
                                                                <Textarea error={step5Errors?.filter((name: { path: string; }) => name.path === `public_policy_holder[${index}]`)?.[0]?.errors?.[0]} contentLoading={contentLoading} myStyle="description" placeholder={item?.description} value={item?.default_description} onChange={(e: any) => { this.onQuestionPolicyPublicHolderChange(index, "default_description", e.target.value) }} />
                                                            </>
                                                        }
                                                    </div>

                                                    {/* } */}
                                                </div>

                                            )
                                            )}
                                        </> }
                                        {this.state.tab === 1 && <>
                                            {!insuredEqualPolicyHolder ? <>
                                                {public_insured && public_insured?.length > 0 && public_insured?.map((item: any, index: number) => (
                                                    <div className={`questionnaire`}>
                                                        <div className="questionnaire-qu-an">
                                                            <span className="question">{index + 1 }<span className="circle"></span>{item?.title}</span>
                                                            <Dropdown error={step5_2Errors?.filter((name: { path: string; }) => name.path === `public_insured[${index}].default_value`)?.[0]?.errors?.[0]} objectList items={item?.value_types} iconBorder displayEmpty myStyle="answer inquery-dropdown " lable="" placeholder="  انتخاب کنید " value={item?.default_value} onChange={(e: any) => { this.onQuestionInsuredPublicChange(index, "default_value", e.target.value) }} />
                                                        </div>

                                                        {/* {value && */}
                                                        <div className="questionnaire-description-box">
                                                        {item?.value_types?.find((item2: { value: string; }) => Number(item2.value) === Number(item.default_value))?.description_required && 
                                                            <>
                                                                {!contentLoading &&
                                                                    <Reply color="#000000" myStyle="reply" />
                                                                }
                                                                <Textarea error={step5_2Errors?.filter((name: { path: string; }) => name.path === `public_insured[${index}]`)?.[0]?.errors?.[0]} contentLoading={contentLoading} myStyle="description" placeholder={item?.description} value={item?.default_description} onChange={(e: any) => { this.onQuestionInsuredPublicChange(index, "default_description", e.target.value) }} />
                                                            </>
                                                        }
                                                        </div>

                                                        {/* } */}
                                                    </div>
                                                )
                                                )}
                                            </> : null
                                            }
                                        </>
                                        }
                                    </div>
                                }
                                {step === 6 &&
                                    (this.props.inqueryData?.start_death_asset > this.props.inqueryData?.minimum_insurance_premium) &&
                                    <div className="inquery-form">
                                        {insuredEqualPolicyHolder ? <>
                                            {/* {contentLoading ? <div className="content-loading hide-mobile"></div> : */}
                                                <div className="row-container hide-mobile">
                                                    <span className="inquery-section-title d-flex align-items-baseline ms-0 w-100">

                                                        سوالات پزشکی بیمه گذار /بیمه شده

                                                        <hr className="hr-line" />
                                                    </span>
                                                </div>
                                            {/* } */}
                                        </> :
                                            <div className="inquery-tab mb-5">

                                                <div className={`${this.state.tab === 0 ? "inquery-tab-item-active" : ""} inquery-tab-item`} onClick={()=>this.setState({tab: 0})}>
                                                    <div className={`${this.state.tab === 0 ? "tab-active" : "tab-deactive"} tab-style`} >
                                                       
                                                    سوالات پزشکی بیمه گذار
                                                    </div>
                                                    {this.state.tab === 0 &&
                                                        <span className="up-arrow"></span>
                                                    }
                                                </div>

                                                <div className={`${this.state.tab === 1 ? "inquery-tab-item-active" : ""} inquery-tab-item`} onClick={()=>this.setState({tab: 1})}>

                                                    <div className={`${this.state.tab === 1 ? "tab-active" : "tab-deactive"} tab-style`} >
                                                       


                                                        سوالات پزشکی بیمه شده
                                                    </div>
                                                    {this.state.tab === 1 &&
                                                        <span className="up-arrow"></span>
                                                    }
                                                </div>
                                            </div>
                                        }
                                        {this.state.tab === 0 && <>
                                            {disease_policy_holder && disease_policy_holder?.length > 0 && disease_policy_holder?.map((item: any, index: number) => (

                                                <div className={`questionnaire`}>
                                                    <div className="questionnaire-qu-an">
                                                        <span className="question mt-1">
                                                            {/* {contentLoading ?
                                                                <div className="input-loading-lable content-loading">
                                                                </div>
                                                                :
                                                                <> */}
                                                                    {index + 1 }<span className="circle"></span>{item?.title}
                                                                {/* </>
                                                            } */}
                                                        </span>
                                                        <Dropdown error={step6Errors?.filter((name: { path: string; }) => name.path === `disease_policy_holder[${index}].default_value`)?.[0]?.errors?.[0]}  objectList items={item?.value_types} iconBorder displayEmpty myStyle="answer inquery-dropdown w-48 " lable="" placeholder="  انتخاب کنید " value={item?.default_value} onChange={(e: any) => { this.onQuestionPolicyHolderChange(index, "default_value", e.target.value) }} />
                                                    </div>

                                                    {/* {value && */}
                                                    <div className="questionnaire-description-box">
                                                        {item?.value_types?.find((item2: { value: string; }) => Number(item2.value) === Number(item.default_value))?.description_required && 
                                                            <>
                                                                {/* {!contentLoading && */}
                                                                    <Reply color="#000000" myStyle="reply" />
                                                                {/* } */}
                                                                <Textarea error={step6Errors?.filter((name: { path: string; }) => name.path === `disease_policy_holder[${index}]`)?.[0]?.errors?.[0]}  myStyle="description" placeholder={item?.description} value={item?.default_description} onChange={(e: any) => { this.onQuestionPolicyHolderChange(index, "default_description", e.target.value) }} />
                                                            </>
                                                        }
                                                    </div>

                                                    {/* } */}
                                                </div>

                                            )
                                            )}
                                        </> } 
                                        {this.state.tab === 1 && <>
                                            {!insuredEqualPolicyHolder ? <>
                                                {disease_insured && disease_insured?.length > 0 && disease_insured?.map((item: any, index: number) => (
                                                    <div className={`questionnaire`}>
                                                        <div className="questionnaire-qu-an">
                                                            <span className="question">{index + 1 }<span className="circle"></span>{item?.title}</span>
                                                            <Dropdown error={step6_2Errors?.filter((name: { path: string; }) => name.path === `disease_insured[${index}].default_value`)?.[0]?.errors?.[0]} objectList items={item?.value_types} iconBorder displayEmpty myStyle="answer inquery-dropdown w-48 " lable="" placeholder="  انتخاب کنید " value={item?.default_value} onChange={(e: any) => { this.onQuestionInsuredChange(index, "default_value", e.target.value) }} />
                                                        </div>

                                                        {/* {value && */}
                                                        <div className="questionnaire-description-box">
                                                        {item?.value_types?.find((item2: { value: string; }) => Number(item2.value) === Number(item.default_value))?.description_required && 
                                                            <>
                                                                {/* {!contentLoading && */}
                                                                    <Reply color="#000000" myStyle="reply" />
                                                                {/* } */}
                                                                <Textarea error={step6_2Errors?.filter((name: { path: string; }) => name.path === `disease_insured[${index}]`)?.[0]?.errors?.[0]}  myStyle="description" placeholder={item?.description} value={item?.default_description} onChange={(e: any) => { this.onQuestionInsuredChange(index, "default_description", e.target.value) }} />
                                                            </>
                                                        }
                                                        </div>

                                                        {/* } */}
                                                    </div>
                                                )
                                                )}
                                            </> : null
                                            }
                                        </>
                                        }
                                    </div>
                                }
                                {step === 7 &&(
                                <>
                                   

                                <div className="tabs-container">
                                
                                    <Tabs
                                        value={tabIndex}
                                        onChange={(event, newValue) => this.handleTabChange(newValue)}
                                        variant="scrollable"
                                        scrollButtons="auto"
                                        aria-label="Proposal Tabs"
                                    >
                                        {tabs.map((tab:any) => (
                                        <Tab key={tab.id} label={tab.label} />
                                        ))}
                                    </Tabs>
                                    </div>

                                    <div className="main-proposal">
                                    {base64Loading ? (
                                        <Skeleton variant="rectangular" width="100%" height={700} />
                                    ) : (
                                        <embed
                                        title="PDF Viewer"
                                        src={base64Data} 
                                        type="application/pdf"
                                        style={{ width: "100%", height: "800px", border: "none" }}
                                        />
                                    )}
                                    </div>
                                </>
                                )}
                                <>
                                    {contentLoading && step !== 6 ? 
                                    <div className="inquery-btn-group">
                                        <div className="content-loading"></div>
                                        <div className="content-loading"></div>
                                    </div> :
                                        <>
                                            {step === 1 ?
                                                <div className="inquery-btn-group">
                                                    {hasError ?
                                                        <>
                                                            <Button myStyle="bg-blue next-btn" title="تایید و مرحله بعد" onClick={() => this.increaseSteper(true)} />
                                                            <Button myStyle="bg-outline-white pre-btn" title="اصلاح اطلاعات" onClick={() => this.clearInquiry()} />
                                                        </>
                                                        :
                                                        <>
                                                            <Button myStyle="bg-blue next-btn" title="مرحله بعد" onClick={() => this.increaseSteper(true)} />
                                                        </>
                                                    }
                                                </div>
                                                :
                                                step === 7 ?


                                                    <>
                                                    <div className="inquery-btn-group">
                                                    <Button loading={this.state.prePaymentLoading} myStyle="bg-green next-btn" title="پرداخت حق بیمه" onClick={() => this.PrePayment()} />
                                                    </div>

                                                       </>
                                                    :
                                                    <div className="inquery-btn-group">
                                                        <Button myStyle="bg-blue next-btn" title="مرحله بعد" onClick={() => this.increaseSteper(true)} />
                                                        <Button myStyle="bg-outline-white pre-btn" title="مرحله قبل" onClick={() => this.decreaseSteper()} />
                                                    </div>
                                            }
                                        </>
                                    }
                                </>
                            </>
                        </div>
                    </div>
                </div>
                <CustomModal myStyle="add-beneficiary overflow-auto " openModal={openBeneficiaryModal} onClose={() => this.handleHideModal()}>
                    <div className="add-beneficiary-container ">
                        <div className="custom-modal-main-title ">
                        <h1 className="title">
                  
                  </h1>
                            <Cancel myStyle="ps-2 hide-desktop" width="20" height="20" color="#000000" onClick={() => this.handleHideModal()} />

                <Cancel myStyle="hide-mobile cursor-pointer hide-mobile" onClick={() => this.handleHideModal()}  />


                        </div>

                        {/*  */}

                        


                        {/*  */}
                        <span className="inquery-title add-beneficiary-title">
                            <span>
                                {beneficiaryModalStep === 1 ?
                                    <>
                                     افزودن  استفاده کننده <span className="details"> {isLife ? "( در صورت حیات)" : " (در صورت فوت)"} </span>
                                    </>

                                    :
                                    <>
                                        تایید اطلاعات
                                    </>
                                }
                            </span>
                        </span>
                        
                        <p className="inquery-description">
                            {beneficiaryModalStep === 1 ? <>
                                جهت افزودن استفاده کننده اطلاعات زیر را تکمیل نمایید
                            </>
                                :
                                <>
                                    در صورت تایید اطلاعات استفاده کننده تایید و باقی مراحل را تکمیل نمایید
                                </>
                            }
                        </p>
                        {beneficiaryModalStep === 1 &&
                            <>

                                <div className="custom-modal-row">
                                    <Dropdown contentLoading={contentLoading} objectList items={filteredRelationPersonList} error={step4Errors?.filter((name: { path: string; }) => name.path === "relation_id")?.[0]?.errors?.[0]} iconBorder displayEmpty myStyle=" custom-modal-item w-48" lable="نسبت با بیمه شده" placeholder="  انتخاب کنید " value={relation_id} onChange={(e: any) => this.handleChangeRelationId(e)} />
                                    <Dropdown disabled={![41,65,68].includes(relation_id)} contentLoading={contentLoading} objectList items={[{value:"0",title:"حقیقی"},{value:"1",title:"حقوقی"}]} error={step4Errors?.filter((name: { path: string; }) => name.path === "person_type")?.[0]?.errors?.[0]} iconBorder displayEmpty myStyle=" custom-modal-item w-48" lable=" شخص " placeholder="  انتخاب کنید " value={person_type} onChange={(e: any) => this.handleChangePersonType(e) } />

                                </div>
                                
                                {![1, 2, 3, 67].includes(relation_id) ?
                                    <div className="custom-modal-row">
                                        <Input disabled={person_type ===""} contentLoading={contentLoading} error={step4Errors?.filter((name: { path: string; }) => name.path === "national_code")?.[0]?.errors?.[0]} hideEndAdornment isRequired type="number" endAdornment="" iconBorder icon={<img src={User} alt="هامرز"/>} myStyle="inquery-input custom-modal-item w-48" lable="کد ملی / شناسه ملی   " value={national_code} onChange={(e: any) => this.setState({ national_code: e })} />
                                        

                                        <DatePickerInput
                                        iconBorder
                                                        ref={this.datePickerRefInsured}
                                                        emptyState={() => this.setState({ birthdayLife: "" })}

                                                        contentLoading={contentLoading}
                                                        error={step4Errors?.filter((name: { path: string; }) => name.path === "birthdayLife")?.[0]?.errors?.[0]}
                                                        value={birthdayLife}
                                                        onChange={(value: any) => this.setState({
                                                            birthdayLife: value,
                                                        })}
                                                        calendarPosition="bottom-right"
                                            containerClassName="date-picker-container w-100"
                                            inputClass="date-picker-input"
                                                         isRequired hideEndAdornment
                                                        //  disabled={(relation_id === 68 || this.checkRelationAndPercent()) || person_type !=="0"}
                                                         disabled={person_type !=="0"}
                                                          myStyle="inquery-input custom-modal-item w-48"
                                                           lable="تاریخ تولد / تاریخ ثبت "
                                                            icon={<img src={Calendar3} alt="هامرز"/>}
                                                            maxDate={new DateObject({
                                                                calendar: persian,
                                                            })}
                                                    />
                                    
                                    </div>

                                    :

                                    null
                                }
                                <div className="custom-modal-row"> 
                                <Input disabled={(relation_id === 68 || this.checkRelationAndPercent()) ||person_type ===""} contentLoading={contentLoading} error={step4Errors?.filter((name: { path: string; }) => name.path === "priority")?.[0]?.errors?.[0]} hideEndAdornment isRequired type="number" endAdornment="" max="1" iconBorder icon={<Money />} myStyle="inquery-input custom-modal-item w-48" lable="اولویت" value={priority} onChange={(e: any) => this.setState({ priority: e })} />
                        {(relation_id === 68 || this.checkRelationAndPercent()) ? 
                        <Dropdown disabled={person_type ===""} contentLoading={contentLoading} objectList
                         items={relation_id === 68 ? sharesList?.filter((item:any) => item.value === 101) : this.checkRelationAndPercent() ? sharesList?.filter((item:any) => item.value === 102) : [] } error={step4Errors?.filter((name: { path: string; }) => name.path === "shareId")?.[0]?.errors?.[0]} iconBorder displayEmpty myStyle=" custom-modal-item w-48" lable="سهم" placeholder="  انتخاب کنید " value={shareId} onChange={(e: any) => {this.setState({shareId:e.target.value})}} />
                                :
                                    <Input disabled={person_type ===""} max="3" contentLoading={contentLoading} error={step4Errors?.filter((name: { path: string; }) => name.path === "percent")?.[0]?.errors?.[0]} hideEndAdornment isRequired type="number" endAdornment="" iconBorder icon={<img src={ChatSquare} alt="هامرز"/>} myStyle="inquery-input custom-modal-item w-48" lable="درصد سهم" value={percent} onChange={(e: any) => this.setState({ percent: e })} />
                        
                        }

                                </div>
                            </>
                        }
                        {beneficiaryModalStep === 2 &&

                            <>
                            {Number(inqueryRegisterOfficeData2?.policy_holder?.type_id) === Number(3) ? 
                            <>
                                <div className="custom-modal-row">
                                    <Input hideEndAdornment type="number" myStyle="custom-modal-item inquery-disable-input w-48 " lable="نام شرکت" value={inqueryRegisterOfficeData2?.policy_holder?.last_name} onChange={() => { }} />
                                    <Input hideEndAdornment type="number" myStyle=" custom-modal-item inquery-disable-input w-48 " lable="تاریخ ثبت" value={moment(`${inqueryRegisterOfficeData2?.policy_holder?.birth_date}`, 'YYYY-M-D').format('jYYYY/jM/jD')} onChange={() => { }} />
                                </div>
                                <div className="custom-modal-row">
                                    <Input hideEndAdornment type="number" myStyle=" custom-modal-item inquery-disable-input w-48 " lable="شناسه ملی " value={inqueryRegisterOfficeData2?.policy_holder?.national_code} onChange={() => { }} />
                                    <Input hideEndAdornment type="number" myStyle="custom-modal-item inquery-disable-input w-48 " lable="شماره ثبت  " value={inqueryRegisterOfficeData2?.policy_holder?.id_no } onChange={() => { }} />
                                </div>


                            </>
                           :
                           <>

                                <div className="custom-modal-row">
                                    <Input hideEndAdornment type="number" myStyle="custom-modal-item inquery-disable-input w-48 " lable="نام" value={inqueryRegisterOfficeData2?.policy_holder?.Name} onChange={() => { }} />
                                    <Input hideEndAdornment type="number" myStyle=" custom-modal-item inquery-disable-input w-48 " lable="نام خانوادگی" value={inqueryRegisterOfficeData2?.policy_holder?.Family} onChange={() => { }} />
                                </div>
                                <div className="custom-modal-row">
                                    <Input hideEndAdornment type="number" myStyle=" custom-modal-item inquery-disable-input w-48 " lable="نام پدر" value={inqueryRegisterOfficeData2?.policy_holder?.FatherName} onChange={() => { }} />
                                    <Input hideEndAdornment type="number" myStyle="custom-modal-item inquery-disable-input w-48 " lable="جنسیت " value={inqueryRegisterOfficeData2?.policy_holder?.Gender === "0" ? "زن" : "مرد"} onChange={() => { }} />
                                </div>
                         </>
                         }
                            </>
                        }
                        <div className="custom-modal-confirm">
                            {contentLoading ? <>
                                <div className="content-loading"></div>
                                <div className="content-loading"></div>
                            </> :
                                <>
                                    <Button myStyle="bg-blue next-btn" title={beneficiaryModalStep === 2 ? " ثبت " : "تایید"} onClick={() => beneficiaryModalStep === 1 ? this.checkObj() : this.addToTable()} />
                                    {beneficiaryModalStep === 2 && 
                                    <Button myStyle="bg-outline-white pre-btn" title="مرحله قبل" onClick={() => this.setState({ beneficiaryModalStep: beneficiaryModalStep - 1 }) } />
                                    }
                                </>
                            }
                        </div>
                    </div>
                </CustomModal>
                <CustomModal myStyle="confirmation-information" openModal={openConfirmationInformationModal} onClose={() => this.setState({ openConfirmationInformationModal: false })}>
                        <div className="confirmation-information-container ">
                            <div className="custom-modal-main-title ">
                                <h1 className="">
                                </h1>
                                <Cancel myStyle="ps-2 hide-desktop" width="20" height="20" color="#000000" onClick={() => this.setState({ openConfirmationInformationModal: false })} />
                                <Cancel myStyle="hide-mobile cursor-pointer hide-mobile" onClick={() => this.setState({ openConfirmationInformationModal: false })} />
                            </div>
                            {/*  */}
                            <span className="title">
                                <span>
                                    کاربر گرامی!
                                </span>
                            </span>
                            {/*  */}
                            <p className="desc">
                            آیا صحت اطلاعات ثبت شده را تایید میکنید؟                             </p>
                            <div className="action-btn-group">
                                <>

                               
                                        <Button loading={contentLoading} myStyle="bg-blue pre-btn" title="تایید اطلاعات" onClick={() => this.createIssuing()} />
                                        <Button myStyle=" bg-outline-white next-btn" title="بازگشت و ویرایش" onClick={() => this.setState({ openConfirmationInformationModal: false })} />
    
                                </>
                            </div>
                        </div>
                    </CustomModal>


            </Layout>
        )
    }
}

const mapStateToProps = (dispatch: any) => {
    return {
        dispatch,
        inqueryData: dispatch.general.inqueryData,
        userData: dispatch.general.userData,
        insuredEqualPolicyHolder: dispatch.general.insuredEqualPolicyHolder,
    };
};
export default connect(mapStateToProps)(Issuing);
